import {
  EntityList,
  EntityListProps,
  renderDate,
  renderStatusIcon,
} from 'components/EntityList'
import { Proving } from 'gql.generated'
import { ConstrainMode, SelectionMode } from 'office-ui-fabric-react'
import * as React from 'react'
import { useTranslation } from 'react-i18next'
import { createFieldColumn } from 'views/helpers'

type ReadProvings_workers = any

export type MyProvingListProps = EntityListProps<ReadProvings_workers>

export const MyProvingList: React.FunctionComponent<MyProvingListProps> = ({
  items,
  ...props
}) => {
  const { t } = useTranslation()

  const fieldColumn = React.useMemo(() => createFieldColumn(t), [t])
  const columns = React.useMemo(
    () => [
      fieldColumn('status', {
        onRender: renderStatusIcon,
        getGroupValue: (item: Proving) => t(`enum.status.${item.status}`),
        isGrouped: true,
        minWidth: 40,
        maxWidth: 60,
      }),
      fieldColumn('provingGround.title', {
        onRender: (item, i, col) => {
          return `${item.provingGround!.title}, ${
            item.provingGround!.countryCode
          }`
        },
        ungroupable: true,
        getGroupValue: (item: Proving) =>
          `${item.provingGround!.title}, ${item.provingGround!.countryCode}`,
      }),
      fieldColumn('dateFrom', {
        onRender: renderDate,
        isSorted: true,

        ungroupable: true,
      }),
      fieldColumn('dateTo', {
        onRender: renderDate,
        ungroupable: true,
      }),

      fieldColumn('title', {
        ungroupable: true,
        minWidth: 320,
      }),
      fieldColumn('id', { ungroupable: true }),
    ],
    [fieldColumn, t]
  )

  return (
    <EntityList
      alternate={true}
      stickyHeader={true}
      selectionMode={SelectionMode.multiple}
      items={items}
      constrainMode={ConstrainMode.horizontalConstrained}
      columns={columns}
      {...props}
    />
  )
}
